import { IS_AWS_ENV } from "constants/app.constants";

import { WellDetailCardData } from "api/data";

import { LifecycleTimeline } from "../blocks/LifecycleTimeline";
import { PerformanceTable } from "../blocks/PerformanceTable";
import { ProductionSummaryTable } from "../blocks/ProductionSummaryTable";
import { WellParametersBlock } from "../blocks/WellParametersBlock";

export interface SummaryTabProps {
  wellData: Maybe<WellDetailCardData>;
  hasProduction: boolean;
}

export function SummaryTab({ wellData, hasProduction }: SummaryTabProps): JSX.Element {
  return (
    <>
      <WellParametersBlock wellData={wellData} />
      {hasProduction &&
        (IS_AWS_ENV ? (
          <ProductionSummaryTable wellData={wellData} />
        ) : (
          <PerformanceTable wellData={wellData} />
        ))}
      <LifecycleTimeline wellData={wellData} />
    </>
  );
}
